import { SiteLink } from "shared/components/SiteLink";
import { SMALL, LARGE } from "shared/utils/constants";
import { SrcSet } from "shared/components/SrcSet";
import cx from "classnames";
import styles from "./Avatar.module.css";
import { useAppContext } from "../utils/useAppContext";

export const Avatar = ({
  _type,
  badge,
  image,
  name,
  slug,
  website,
  titles,
  size,
}) => {
  const titlesObject = titles?.length > 0 ? titles[0] || {} : {};
  const currentScope = useAppContext().scope;

  return (
    <div className={cx(styles.avatar, { [styles.large]: size === LARGE })}>
      <div className={styles.imageContainer}>
        {image && (
          <SrcSet
            alt={name}
            sizes={[{ minWidth: 1, width: size === LARGE ? 72 : 56, ratio: 1 }]}
            src={image.url}
          />
        )}
        {badge && <div className={styles.badge}>{badge}</div>}
      </div>
      <div>
        <strong className={styles.name}>
          {slug || website ? (
            <SiteLink
              href={slug ? slug.current : website}
              size={website ? SMALL : null}
              type={slug ? _type : null}
              isOutOfScope={currentScope === "Ineo"}
            >
              {name}
            </SiteLink>
          ) : (
            name
          )}
        </strong>
        {titles?.length > 0 && (
          <p className={styles.title}>
            {[titlesObject.title, titlesObject.organization]
              .filter(Boolean)
              .join(", ")}
          </p>
        )}
      </div>
    </div>
  );
};
